export const RQ_GET_DAILY_REPORTS_API_ = {
  url:'reports/web/effort/dailyeffort/<%= locationId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>?callTypeId=<%= callTypeId %>&entityTagId=<%= entityTagId %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_NEW_DAILY_REPORTS_API = {
  url:'reports/web/effort/newdailyeffort/<%= locationId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>?callTypeId=<%= callTypeId %>&entityTagId=<%= entityTagId %>',
  method:'GET',
  auth:true,
};
